/**
 * PDP Free Gift widget — keeps the displayed gift quantity in step with the
 * mattress size the shopper has selected.
 *
 * Display only. The gift is added to the cart by the Monk app; nothing here
 * writes to the cart or creates a discount. All this does is make sure the card
 * says "1 x" when a Single is selected and "2 x" when a Queen is, along with
 * the matching struck-through value.
 *
 * Both money strings are pre-formatted in Liquid and carried on data
 * attributes, so this file never has to format currency — which keeps it
 * correct for any market the theme is later used in.
 */
(function () {
  'use strict';

  // The snippet loads this once per block; guard so a second block on the page
  // cannot double-subscribe to variant changes.
  if (window.__pdpFreeGiftInit) return;
  window.__pdpFreeGiftInit = true;

  function parseJSON(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return fallback;
    }
  }

  function norm(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  /**
   * Smaller quantity only for the sizes the merchant listed; everything else
   * gets the larger one. Defaulting an unknown size UP is deliberate — if a new
   * size is added in admin and nobody updates this list, the shopper is over-
   * promised rather than under-delivered, which surfaces as a merchandising
   * question instead of a silent downgrade.
   */
  function quantityFor(widget, sizeValue) {
    var wanted = norm(sizeValue);
    var isSmall = widget._smallSizes.some(function (s) {
      return norm(s) === wanted;
    });
    return isSmall ? widget._qtySmall : widget._qtyLarge;
  }

  function render(widget, sizeValue) {
    var qty = quantityFor(widget, sizeValue);
    var money = qty === widget._qtySmall ? widget._moneySmall : widget._moneyLarge;

    var strike = widget.querySelector('[data-fg-strike]');
    var title = widget.querySelector('[data-fg-card-title]');
    var value = widget.querySelector('[data-fg-card-value]');

    if (strike) strike.textContent = money;
    // A merchant-written title describes the whole offer across every size,
    // so it is fixed copy — only the generated "{qty} x {name}" line tracks
    // the selected size.
    if (title && !widget._titleLocked) title.textContent = qty + ' x ' + widget._name;
    if (value) value.textContent = widget._valueTemplate.replace('[value]', money);
  }

  /** The mattress option value this widget keys off, for a given variant. */
  function valueFromVariant(widget, variant) {
    if (!variant || !variant.options) return null;
    var index = widget._mainOptions.indexOf(widget.dataset.fgOptionName);
    if (index === -1) index = 0;
    return variant.options[index];
  }

  function initWidget(widget) {
    if (widget._fgReady) return;
    widget._fgReady = true;

    var smallEl = widget.querySelector('[data-fg-small-sizes]');
    widget._smallSizes = smallEl ? parseJSON(smallEl.textContent, []) : [];
    widget._qtySmall = parseInt(widget.dataset.fgQtySmall, 10) || 1;
    widget._qtyLarge = parseInt(widget.dataset.fgQtyLarge, 10) || 2;
    widget._moneySmall = widget.dataset.fgMoneySmall || '';
    widget._moneyLarge = widget.dataset.fgMoneyLarge || '';
    widget._name = widget.dataset.fgName || '';
    widget._valueTemplate = widget.dataset.fgValueTemplate || '[value]';
    widget._titleLocked = widget.dataset.fgTitleLocked === 'true';
    widget._mainOptions = parseJSON(widget.dataset.fgMainOptions, []);

    var initial = parseJSON(widget.dataset.fgMainInitial, []);
    var index = widget._mainOptions.indexOf(widget.dataset.fgOptionName);
    if (index === -1) index = 0;
    render(widget, initial[index]);
  }

  function initAll() {
    document.querySelectorAll('[data-free-gift]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-render whenever the mattress variant changes — the same theme pub/sub
  // event the add-on block and promotional-badges.js already use.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data ? event.data.variant : null;
      if (!variant) return;
      document.querySelectorAll('[data-free-gift]').forEach(function (widget) {
        initWidget(widget);
        render(widget, valueFromVariant(widget, variant));
      });
    });
  }
})();
